import './index.css';
import queryClient from '@lib/queryClient';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import { Provider } from 'react-redux';
import React from 'react';
import { QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import store from 'app/store';
import theme from '../theme';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'devextreme/dist/css/dx.common.css';
import { createRoot } from 'react-dom/client';
import 'devextreme/dist/css/dx.light.css';
// LANGUAGE
import './i18n/index';
// CSS
import 'bootstrap-daterangepicker/daterangepicker.css';
import 'rc-tooltip/assets/bootstrap.css'; // sẽ có cái cần dùng đến tooltip này
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { GlobalStyles } from 'styles/Global';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import Loading from '@components/common/Loading';

const persistor = persistStore(store);

// tắt log khi chạy thực luôn
// if (process.env.NODE_ENV === 'production') {
//   console.log = () => {
//     //
//   };
//   console.error = () => {
//     //
//   };
//   console.debug = () => {
//     //
//   };
// }

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient()}>
        <ThemeProvider theme={theme}>
          <ConfigProvider locale={enUS}>
            <PersistGate loading={<Loading />} persistor={persistor}>
              <BrowserRouter>
                <GlobalStyles />
                <App />
              </BrowserRouter>
            </PersistGate>
          </ConfigProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
